import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

import { computed } from "vue";
import { formatFloat } from "@/helpers";

import { useGameStateStore } from "@/store/gameState";


export default /*#__PURE__*/_defineComponent({
  __name: 'Stats',
  setup(__props) {

const statsClassName = "stats";

const state = useGameStateStore();

const statsData = computed(() => [
  {
    label: "Try:",
    value: state.getTotalsPlays,
  },
  {
    label: "Won after switch:",
    value: state.totalSwitchWins / state.totalSwitchPlays,
  },
  {
    label: "Won after stay:",
    value: state.totalStayWins / state.totalStayPlays,
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(statsClassName)
  }, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statsData), ({ label, value }, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("div", null, _toDisplayString(label), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(formatFloat)(value)), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})